export interface UserParameter {
  Name: string;
  Required: boolean;
  Value: string;
}

// Interface to handle API response with typo
export interface UserParameterResponse {
  Name: string;
  Required?: boolean;
  Requiered?: boolean; // Handle the typo in API response
  Value: string;
}

export interface ProjectInfoResponse {
  PNAME?: string; // Project Name (old format)
  SER?: string;   // Serial Number (old format)
  LTR?: string;   // Last Telemetry Received (old format)
  
  // New API format
  ProjectName?: string;
  SerialNumber?: string;
  LastTelemetryReceived?: string | null;
  FiberType?: string;
  Version?: string;
  CustomerName?: string;
  
  UserParameter: UserParameterResponse[];
}

export class ProjectInfo implements ProjectInfoResponse {
  PNAME: string;
  SER: string;
  LTR: string;
  UserParameter: UserParameter[];
  
  // Properties for both old and new API formats
  ProjectName: string;
  SerialNumber: string;
  LastTelemetryReceived: string | null;
  FiberType: string;
  Version: string;
  CustomerName: string;

  constructor(data: ProjectInfoResponse) {
    // Handle both old and new API formats
    this.PNAME = data.PNAME || data.ProjectName || '';
    this.SER = data.SER || data.SerialNumber || '';
    this.LTR = data.LTR || data.LastTelemetryReceived || '';
    
    // Clean and normalize UserParameter data
    this.UserParameter = (data.UserParameter || []).map(param => ({
      Name: param.Name,
      Required: param.Required !== undefined ? param.Required : (param.Requiered || false),
      Value: param.Value
    }));
    
    // Set properties for both formats
    this.ProjectName = this.PNAME;
    this.SerialNumber = this.SER;
    this.LastTelemetryReceived = this.LTR;
    this.FiberType = data.FiberType || '';
    this.Version = data.Version || '';
    this.CustomerName = data.CustomerName || '';
    
    console.log('ProjectInfo constructor - Input data:', data);
    console.log('ProjectInfo constructor - FiberType:', data.FiberType, '-> Final:', this.FiberType);
    console.log('ProjectInfo constructor - Version:', data.Version, '-> Final:', this.Version);
    console.log('ProjectInfo constructor - CustomerName:', data.CustomerName, '-> Final:', this.CustomerName);
    console.log('ProjectInfo constructor - UserParameter:', this.UserParameter);
  }

  // Helper method to get user parameter keys as a searchable string
  getUserParameterKeys(): string {
    return this.UserParameter.map(param => param.Name).join(', ');
  }

  // Helper method to get user parameter values as a searchable string
  getUserParameterValues(): string {
    return this.UserParameter.map(param => param.Value).join(', ');
  }

  // Helper method to get all user parameters as a searchable string
  getUserParametersText(): string {
    return this.UserParameter.map(param => `${param.Name}: ${param.Value}`).join(', ');
  }

  // Helper method to get user parameter value by name
  getUserParameterValue(paramName: string): string {
    const param = this.UserParameter.find(p => p.Name === paramName);
    return param ? param.Value : '';
  }

  // Static method to get all unique user parameter names from a list of projects
  static getAllUserParameterNames(projects: ProjectInfo[]): string[] {
    const allNames = new Set<string>();
    projects.forEach(project => {
      project.UserParameter.forEach(param => {
        allNames.add(param.Name);
      });
    });
    return Array.from(allNames).sort();
  }
}
